export default __webpack_public_path__ + "static/media/book.2ce1dd48.png";